module.exports = __webpack_public_path__ + "img/7.4c575de7.jpg";